import React from 'react';
import { useSelector } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import {
    WorksheetPageIndex,
    WorksheetEntitySummaryIndex
} from 'services/worksheet/types';
import { makeSelectHectares } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    entitySummaryIndex: WorksheetEntitySummaryIndex;
}

type Props = OwnProps;

export default function HectaresTableCell(props: Props): React.ReactElement {
    const hectares = useSelector((state: AppState) =>
        makeSelectHectares()(state, props)
    );

    return <TableCell>{hectares}</TableCell>;
}
